import api from "../index"

const investorsIcdsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFundRequests: build.query({
      query: (params) => ({
        url: `/investor/icds/fund-requests`,
        method: "GET",
        params,
      }),
    }),
    myIcdRequests: build.query({
      query: (params) => ({
        url: `/investor/icds/my-icd-requests`,
        method: "GET",
        params,
      }),
    }),
    viewMyIcdRequests: build.query({
      query: ({ id }) => ({
        url: `/investor/icds/my-icd-requests/view/${id}`,
        method: "GET",
      }),
    }),
    myIcdPayments: build.query({
      query: (params) => ({
        url: `/investor/icds/my-icd-payments`,
        method: "GET",
        params,
      }),
    }),
    createFundRequest: build.mutation({
      query: (params) => ({
        url: `/investor/icds/create`,
        method: "POST",
        body: params,
      }),
    }),
    deleteIcdRequest: build.mutation({
      query: ({ id }) => ({
        url: `/investor/icds/delete/${id}`,
        method: "DELETE",
      }),
    }),
    myInterests: build.query({
      query: (params) => ({
        url: `/investor/icds/my-interests`,
        method: "GET",
      }),
    }),
    showInterest: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/investor/icds/show-interest/${id}`,
        method: "GET",
      }),
    }),
    counterOffer: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/investor/icds/counter-offer/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    approveOfferInvestor: build.mutation({
      query: ({ id }) => ({
        url: `/investor/icds/approve/${id}`,
        method: "GET",
      }),
    }),
    rejectOfferInvestor: build.mutation({
      query: ({ id }) => ({
        url: `/investor/icds/reject/${id}`,
        method: "GET",
      }),
    }),
    icdSignNewAgreement: build.mutation({
      query: (body) => ({
        url: `/investor/icds/sign/agreement`,
        method: "POST",
        body,
      }),
    }),
    getSignDocuments: build.query({
      query: () => ({
        url: `/investor/icds/signed-documents`,
        method: "GET",
      }),
    }),
    getSignDocumentWealthPartner: build.query({
      query: () => ({
        url: `/wealthPartner/icds/signed-documents`,
        method: "GET",
      }),
    }),
    icdPayment: build.mutation({
      query: (body) => ({
        url: `/investor/icds/payment`,
        method: "POST",
        body,
      }),
    }),
    getSigningRequests: build.query({
      query: (params) => ({
        url: `/investor/icds/signing-requests`,
        method: "GET",
        params,
      }),
    }),
  }),
})

export const {
  useLazyGetFundRequestsQuery,
  useLazyMyIcdRequestsQuery,
  useCreateFundRequestMutation,
  useDeleteIcdRequestMutation,
  useShowInterestMutation,
  useCounterOfferMutation,
  useLazyMyInterestsQuery,
  useApproveOfferInvestorMutation,
  useRejectOfferInvestorMutation,
  useLazyViewMyIcdRequestsQuery,
  useIcdSignNewAgreementMutation,
  useLazyGetSignDocumentsQuery,
  useIcdPaymentMutation,
  useLazyGetSigningRequestsQuery,
  useLazyMyIcdPaymentsQuery,
  useLazyGetSignDocumentWealthPartnerQuery,
} = investorsIcdsApi
